<template>
    <div class="bun-canvas configurator-element">
        <BunName></BunName>
        <Bun></Bun>
        <EmojiLibrary />

        <div class="section-footer">
            <div class="disclaimer">
                {{ $t('notification.disclaimer')}}
            </div>
        </div>
    </div>
</template>

<script>
    import BunName from "./BunName";
    import Bun from "./Bun";
    import EmojiLibrary from "./Emoji/EmojiLibrary";

    export default {
        name: "BunCanvas",
        components: {EmojiLibrary, Bun, BunName},
    }
</script>